import React from 'react';

export default function Footer() {
  return (
    <footer className="bg-black small text-center text-white-50">
      <div className="footer-container">
        <p>admin@crowdbuild.com.au  </p>
      </div>
      <div className="footer-container">
        <p>© {new Date().getFullYear()}{' '}<a href="https://crowdbuild.com.au/">Crowd Build Property Investment Fund</a></p>        
      </div>
    </footer>
  );
}
